/* eslint-disable camelcase */
/* eslint-disable import/no-cycle */
import { sharedStore } from '@ncl/rootStore/rootStore.model';
import AccountServices from '@ncl/modules/account/services/AccountServices';
import httpErrorsWithelist from '@ncl/json/httpErrorsWithelist.json';
import { formatRequestErrorResponse, retryAxios } from './httpHelpers';
import juntoAnalyticsService from '../../../services/analytics/JuntoAnalyticsService';
import errorCaughtAdapter from '../../../services/analytics/adapters/ErrorCaughtAdapter';

export async function httpErrorHandler(e, axiosInstance) {
  const { response, config, code } = e;
  const { url, numberOfRequests } = config;
  const statusCode = response?.status;
  const { ignoreBehavior } = isErrorWhitelisted(url, statusCode);
  const forceRetry = ['/terms/privacy', '/terms/liability'].some((l) => url.includes(l));
  const ignoreUnauthorized = [
    '/account/login',
    '/account/register/agent',
    '/account/register/policyholder',
  ].some((l) => url.includes(l));
  const connectionAborted = code === 'ECONNABORTED';

  if (
    statusCode === 401 &&
    !ignoreUnauthorized &&
    process.env.REACT_APP_FEATURE_KEYCLOAK_AUTH === 'true'
  ) {
    const refreshResponse = await AccountServices.refreshToken();
    if (!refreshResponse) {
      AccountServices.removeAccessTokenCookie();
      return formatRequestErrorResponse(response, connectionAborted, ignoreBehavior);
    }
    const {
      data: { access_token, refresh_token, refresh_expires_in },
    } = refreshResponse;
    AccountServices.setAccessTokenCookie(access_token, refresh_expires_in);
    AccountServices.setRefreshTokenCookie(refresh_token, refresh_expires_in);

    const enhancedConfig = { ...config, headers: { Authorization: `bearer ${access_token}` } };
    return retryAxios(enhancedConfig, axiosInstance);
  }

  if (!ignoreBehavior || !ignoreBehavior.juntoAnalytics) {
    sendErrorToJuntoAnalytics({ response, config });
  }

  if ((statusCode !== undefined || connectionAborted) && !forceRetry) {
    sharedStore.closeConnectionModal();
    return formatRequestErrorResponse(response, connectionAborted, ignoreBehavior);
  }

  const enhancedConfig = { ...config, numberOfRequests: numberOfRequests || 1 };
  return retryAxios(enhancedConfig, axiosInstance);
}

export function httpSuccessHandler(response) {
  sharedStore.closeConnectionModal();
  let success = true;
  if (response.data.success === false) success = false;

  const result = {
    success,
    data: response.data.data || response.data,
    errors: response.data.errors || [],
  };

  return result;
}

export function httpSetRequestHeaders(config) {
  const accessToken = AccountServices.getAccessTokenCookie();
  const ignoreAuthorization = ['/account/login', '/account/refresh'];
  const newConfig = config;
  if (accessToken && !ignoreAuthorization.includes(config.url)) {
    newConfig.headers.Authorization = `bearer ${accessToken}`;
  } else {
    delete newConfig.headers.Authorization;
  }

  return newConfig;
}

export const interceptors = {
  response: {
    success: httpSuccessHandler,
    error: httpErrorHandler,
  },
  request: httpSetRequestHeaders,
};

function sendErrorToJuntoAnalytics(http) {
  juntoAnalyticsService.sendCustomEvent({ ...http }, errorCaughtAdapter, 'error_caught');
}

function isErrorWhitelisted(url, statusCode) {
  return (
    httpErrorsWithelist.find(
      (error) => error.route === url && error.expectedErrorCodes.includes(statusCode)
    ) || { ignoreBehavior: false }
  );
}
